<script setup>
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

// Карточка «Сайт (виджет)» внутри вкладки «Каналы» — точная копия
// websiteCard() из platform-backend/views/embed.ejs (строки ~2547-2572).
// Только для чтения: скрипт и ссылка виджета формируются на бэкенде.
defineProps({
  channel: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const copy = async text => {
  try {
    await copyTextToClipboard(text);
    useAlert(t('SOURCE_MGMT.CHANNELS.WEBSITE.COPIED'));
  } catch (error) {
    useAlert(error.message);
  }
};
</script>

<template>
  <div
    class="flex flex-col gap-3 p-4 rounded-xl bg-n-alpha-1 outline outline-1 outline-n-container"
  >
    <div class="flex items-center gap-2 flex-wrap">
      <h4 class="text-heading-3 text-n-slate-12 m-0">
        {{ t('SOURCE_MGMT.CHANNELS.WEBSITE.TITLE') }}
      </h4>
      <span
        class="inline-flex items-center rounded-full px-2 py-0.5 text-label-small"
        :class="
          channel.hasOwnWidget
            ? 'bg-n-teal-3 text-n-teal-11'
            : 'bg-n-slate-3 text-n-slate-11'
        "
      >
        {{
          channel.sourceCode
            ? t('SOURCE_MGMT.CHANNELS.WEBSITE.OWN_BRAND', {
                code: channel.sourceCode,
              })
            : t('SOURCE_MGMT.CHANNELS.WEBSITE.SHARED')
        }}
      </span>
    </div>

    <template v-if="channel.widgetScript">
      <span class="text-label-small text-n-slate-11">
        {{ t('SOURCE_MGMT.CHANNELS.WEBSITE.SCRIPT_LABEL') }}
      </span>
      <div
        class="text-label-small text-n-slate-11 break-all select-all cursor-pointer"
        @click="copy(channel.widgetScript)"
      >
        {{ channel.widgetScript }}
      </div>
    </template>

    <template v-if="channel.widgetUrl">
      <span class="text-label-small text-n-slate-11">
        {{ t('SOURCE_MGMT.CHANNELS.WEBSITE.LINK_LABEL') }}
      </span>
      <div
        class="text-label-small text-n-slate-11 break-all select-all cursor-pointer"
        @click="copy(channel.widgetUrl)"
      >
        {{ channel.widgetUrl }}
      </div>
    </template>
    <div v-else class="text-body-main text-n-slate-11">
      {{ t('SOURCE_MGMT.CHANNELS.WEBSITE.NO_KEY') }}
    </div>

    <div class="text-body-main text-n-slate-11">
      {{
        channel.hasOwnWidget
          ? t('SOURCE_MGMT.CHANNELS.WEBSITE.OWN_INBOX', {
              id: channel.widgetInboxId || '?',
            })
          : t('SOURCE_MGMT.CHANNELS.WEBSITE.SHARED_INBOX')
      }}
    </div>

    <div v-if="channel.hint" class="text-body-main text-n-slate-11">
      {{ channel.hint }}
    </div>
  </div>
</template>
